const SUPPORTED_PREFERENCES = [
  "hide_description",
  "hide_social_links", 
  "hide_cta",
  "hide_members_count",
  "show_application_fee",
  "allow_invoicing",
  "allow_minting"
];

export const appendPreferences = (formData, preferences) => {
  Object.entries(preferences).forEach(([key, value]) => {
    if (SUPPORTED_PREFERENCES.includes(key) && value) {
      formData.append('preferences[]', key);
    }
  });
};